<template>
  <layouts-header
    style="background: linear-gradient(45deg, #28a745, #20c997)"
  ></layouts-header>
  <!-- <breadcrumb
    :title="title"
    :text="carDetails?.car?.brand?.name"
    :text1="carDetails?.car?.model?.name"
  /> -->
  <listing-head :car-details="carDetails"></listing-head>
  <section class="section product-details">
    <div class="container">
      <div class="row">
        <LoaderCard v-if="isLoading" :count="6" />
        <div v-else class="col-lg-8">
          <listing-carphoto :car-details="carDetails"></listing-carphoto>

          <listing-description
            :car-description="carDetails?.car?.description"
          ></listing-description>

          <!--Listing Features Section-->
          <listing-specifications
            :car-details="carDetails"
          ></listing-specifications>

          <listing-features
            title="مواصفات السيارة"
            :features="carDetails?.car?.specifications"
          ></listing-features>
          <listing-features
            title="المواصفات الخارجية للسيارة"
            :features="carDetails?.car?.external_specification"
          ></listing-features>
          <listing-features
            title="المواصفات الفنية للسيارة"
            :features="carDetails?.car?.technical_specifications"
          ></listing-features>

          <!--/Listing Features Section-->

          <!-- Gallery -->
          <listing-gallery
            :car-images="carDetails?.car?.images"
          ></listing-gallery>
          <!-- /Gallery -->

          <!-- Video -->
          <!-- <div class="review-sec mb-0">
            <div class="review-header">
              <h4>Video</h4>
            </div>
            <div class="short-video">
              <img class="img-fluid" alt="Image" src="@/assets/img/video-img.jpg" />
              <a
                href="https://www.youtube.com/embed/ExJZAegsOis"
                data-fancybox="video"
                class="video-icon"
              >
                <i class="bx bx-play"></i>
              </a>
            </div>
          </div> -->
          <!-- /Video -->

          <!-- الأسئلة الشائعة -->
          <!-- <div class="review-sec faq-feature">
            <div class="review-header">
              <h4>الأسئلة الشائعة</h4>
            </div>
            <div class="faq-info">
              <div class="faq-card">
                <h4 class="faq-title">
                  <a
                    class="collapsed"
                    data-bs-toggle="collapse"
                    href="#faqOne"
                    aria-expanded="false"
                  >
                    كم يجب أن يكون عمري لاستئجار سيارة؟
                  </a>
                </h4>
                <div id="faqOne" class="card-collapse collapse">
                  <p>
                    نحن نقدم أسطولًا متنوعًا من المركبات لتلبية جميع الاحتياجات،
                    بما في ذلك السيارات الصغيرة، السيدان، سيارات الدفع الرباعي،
                    والسيارات الفاخرة. يمكنك تصفح مجموعتنا عبر الإنترنت أو
                    التواصل معنا لمساعدتك في اختيار السيارة المناسبة لك.
                  </p>
                </div>
              </div>

              <div class="faq-card">
                <h4 class="faq-title">
                  <a
                    class="collapsed"
                    data-bs-toggle="collapse"
                    href="#faqTwo"
                    aria-expanded="false"
                  >
                    ما هي المستندات المطلوبة لاستئجار سيارة؟
                  </a>
                </h4>
                <div id="faqTwo" class="card-collapse collapse">
                  <p>
                    يجب أن تقدم رخصة قيادة سارية المفعول، وبطاقة هوية أو جواز
                    سفر، وبطاقة دفع (ائتمانية أو خصم مباشر) لضمان عملية
                    الاستئجار.
                  </p>
                </div>
              </div>

              <div class="faq-card">
                <h4 class="faq-title">
                  <a
                    class="collapsed"
                    data-bs-toggle="collapse"
                    href="#faqThree"
                    aria-expanded="false"
                  >
                    ما أنواع السيارات المتوفرة للإيجار؟
                  </a>
                </h4>
                <div id="faqThree" class="card-collapse collapse">
                  <p>
                    نوفر سيارات صغيرة، سيارات سيدان، سيارات رياضية متعددة
                    الاستخدام (SUV)، وسيارات فاخرة لتلبية جميع الاحتياجات.
                  </p>
                </div>
              </div>

              <div class="faq-card">
                <h4 class="faq-title">
                  <a
                    class="collapsed"
                    data-bs-toggle="collapse"
                    href="#faqFour"
                    aria-expanded="false"
                  >
                    هل يمكنني استئجار سيارة باستخدام بطاقة خصم مباشر؟
                  </a>
                </h4>
                <div id="faqFour" class="card-collapse collapse">
                  <p>
                    نعم، يمكن استئجار السيارة باستخدام بطاقة خصم مباشر، ولكن قد
                    تكون هناك شروط إضافية أو وديعة تأمين تُطبق.
                  </p>
                </div>
              </div>
            </div>
          </div> -->
          <!-- /الأسئلة الشائعة -->

          <!-- السياسات -->
          <!-- <div class="review-sec">
            <div class="review-header">
              <h4>السياسات</h4>
            </div>
            <div class="policy-list">
              <div class="policy-item">
                <div class="policy-info">
                  <h6>رسوم الإلغاء</h6>
                  <p>تُطبق رسوم الإلغاء وفقًا للسياسة المتبعة.</p>
                </div>
                <router-link to="/pages/privacy-policy"
                  >اعرف المزيد</router-link
                >
              </div>
              <div class="policy-item">
                <div class="policy-info">
                  <h6>السياسة</h6>
                  <p>
                    أوافق بموجب هذا على الشروط والأحكام المنصوص عليها في اتفاقية
                    الإيجار مع المضيف.
                  </p>
                </div>
                <router-link to="/pages/privacy-policy"
                  >عرض التفاصيل</router-link
                >
              </div>
            </div>
          </div> -->
          <!-- /السياسات -->

          <!-- <listing-review></listing-review> -->
        </div>
        <listingdetails-sidebar
          v-if="!isLoading"
          :car-details="carDetails"
        ></listingdetails-sidebar>
      </div>
      <listing :car-likes="carDetails?.car_likes"></listing>
    </div>
  </section>
  <layout-footer></layout-footer>
  <listing-modal></listing-modal>
</template>
<script>
import { onMounted, computed } from "vue";
import { useCarStore } from "@/stores/car";
import { useRoute } from "vue-router";
import LoaderCard from "@/components/common/LoaderCard.vue";

export default {
  components: {
    LoaderCard,
  },
  data() {
    return {
      title: "Chevrolet Camaro",
      text: "Listings",
      text1: "Chevrolet Camaro",
    };
  },
  setup() {
    const carStore = useCarStore();
    const isLoading = computed(() => carStore.isLoading);

    onMounted(() => {
      const route = useRoute();
      const id = route.params.carId || 516;
      carStore.getCarDetails(id).then(() => {});
    });

    const carDetails = computed(() => carStore.carDetails);

    return {
      carDetails,
      isLoading,
    };
  },
};
</script>
